import React from 'react';
import './CreateCampaignModal.css';

export default function BriefCreatedModal({ isOpen, onClose, briefName, onCreateScript }) {
  if (!isOpen) return null;
  return (
    <div className="create-campaign-modal-overlay">
      <div className="campaign-created-modal">
        <div className="campaign-created-content">
          <h3 className="campaign-created-title">🎉 Brief Created!</h3>
          <p className="campaign-created-message">
            <strong>'{briefName}'</strong> is saved and ready for script creation.
          </p>
        </div>

        <div className="campaign-created-actions">
          <button className="campaign-created-secondary-btn" onClick={onClose}>
            Stay Here
          </button>
          <button className="campaign-created-primary-btn" onClick={onCreateScript}>
            Create Script
          </button>
        </div>
      </div>
    </div>
  );
}










